import React from "react";
import { Helmet } from "react-helmet-async";
import { SITE_URL } from "../seo/pages";

// Per-route <head> management. Canonical, title, description and Open Graph are
// set here so each URL is indexed as its own page. WebPage + BreadcrumbList JSON-LD
// is emitted per page (site-wide entities live statically in index.html).
export const Seo = ({ page }) => {
  const url = page.path === "/" ? `${SITE_URL}/` : `${SITE_URL}${page.path}`;

  const webPage = {
    "@type": "WebPage",
    "@id": `${url}#webpage`,
    url,
    name: page.title,
    description: page.description,
    inLanguage: "en-US",
    isPartOf: { "@id": `${SITE_URL}/#website` },
    about: { "@id": `${SITE_URL}/#organization` },
    primaryImageOfPage: { "@id": `${SITE_URL}/#primaryimage` },
  };

  const crumbs =
    page.path === "/"
      ? [{ name: "Home", item: `${SITE_URL}/` }]
      : [
          { name: "Home", item: `${SITE_URL}/` },
          { name: page.label, item: url },
        ];

  const breadcrumb = {
    "@type": "BreadcrumbList",
    "@id": `${url}#breadcrumb`,
    itemListElement: crumbs.map((c, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: c.name,
      item: c.item,
    })),
  };

  const graph = { "@context": "https://schema.org", "@graph": [webPage, breadcrumb] };

  return (
    <Helmet>
      <title>{page.title}</title>
      <meta name="description" content={page.description} />
      <link rel="canonical" href={url} />

      <meta property="og:title" content={page.title} />
      <meta property="og:description" content={page.description} />
      <meta property="og:url" content={url} />

      <meta name="twitter:title" content={page.title} />
      <meta name="twitter:description" content={page.description} />

      <script type="application/ld+json">{JSON.stringify(graph)}</script>
    </Helmet>
  );
};
